import { ImageStyle, Platform, TextStyle, ViewStyle, StyleSheet } from 'react-native';
import { mbApplyTransparency } from './mbApplyTransparency';

interface mbShadowProps {
  color: string;
  opacity: number;
  radius: number;
  offsetWidth: number;
  offsetHeight: number;
  elevation: number;
}

/**
 * Takes shadow props and generates styles approriate for the platform.
 * @param props mbShadowProps
 * @returns Styles that can be applied to a View, Text or Image,
 */
const mbShadow = (props: mbShadowProps): ViewStyle | TextStyle | ImageStyle => {
  let shadowColor = props.color;
  if (shadowColor.length !== 7 || shadowColor[0] !== '#') {
    console.error('ERROR: mbShadow: color must be a hex string in the format #RRGGBB');
    shadowColor = '#000000';
  }

  return StyleSheet.flatten(
    Platform.select({
      ios: {
        shadowColor: shadowColor,
        shadowOpacity: props.opacity,
        shadowRadius: props.radius,
        shadowOffset: {
          width: props.offsetWidth,
          height: props.offsetHeight,
        },
      },
      android: {
        elevation: props.elevation,
      },
      web: {
        boxShadow: `${props.offsetWidth}px ${props.offsetHeight}px ${props.radius}px ${mbApplyTransparency(shadowColor, props.opacity)}`,
      },
    })
  );
};

export { mbShadow };
